'use es6';

import { useState, useEffect } from 'react';
const useMediaQuery = mediaQuery => {
  const [isMatching, setIsMatching] = useState(!!window.matchMedia(mediaQuery).matches);
  useEffect(() => {
    const mql = window.matchMedia(mediaQuery);
    const changeHandler = e => setIsMatching(!!e.matches);
    mql.addListener(changeHandler);
    return () => {
      mql.removeListener(changeHandler);
    };
  }, [mediaQuery]);
  return isMatching;
};
export default useMediaQuery;